/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function customDesktopSearch() {
    var x = document.getElementById('custom-desktop-search');
    if (x.style.display === 'block') {
        x.style.display = 'none';
    } else {
        x.style.display = 'block';
    }
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}
function j_delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1000);
    var cval = getCookie(name);
    document.cookie = name + '=' + cval + '; expires=' + 'Thu, 01 Jan 1970 00:00:01 GMT;path=/';
}
function delete_cookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function trackCookieJourney(flag) {
    setCookie('hkbn_journey_url', flag);
    window.location.href = '/account?view=edit';
}

var isLoginPage = document.getElementsByClassName('template-login');
if (isLoginPage.length > 0) {
    if (getCookie('hkbn_status') == 'ec') {
        setCookie('hkbn_status', '');
        //window.location.href = "https://www.hkbn.net/User/SSOSignOut";
        window.location.href = 'https://www.hkbn.net/personal/User/SSOSignOut';
    }

    if (getCookie('hkbn_status') == 'talent') {
        setCookie('hkbn_status', '');
        window.location.href = 'https://cloudapp.hkbn.net/shopify/sso/logout';
    }
}

function hkbn_logout_ec() {
    var channel_id = sessionStorage.getItem('channel_id');
    //if(channel_id=='CS-TS'){
    j_delCookie('cart');
    //}
    sessionStorage.removeItem('channel_id');
    sessionStorage.removeItem('campaign_key');
    setCookie('hkbn_status', 'ec');
    window.location.href = '/account/logout';
}
function hkbn_logout_nc() {
    var channel_id = sessionStorage.getItem('channel_id');
    //if(channel_id=='CS-TS'){
    j_delCookie('cart');
    //}
    sessionStorage.removeItem('channel_id');
    setCookie('hkbn_status', 'nc');
    window.location.href = '/account/logout';
}
function hkbn_logout_talent() {
    j_delCookie('cart');
    setCookie('hkbn_status', 'talent');
    window.location.href = '/account/logout';
}

if (getCookie('hkbn_journey_url')) {
    var isAccountpage = document.getElementsByClassName('template-account');
    if (isAccountpage.length > 0) {
        document.getElementById('isHomepageBtn').style.display = 'none';
        if (getCookie('hkbn_journey_url') == '/cart') {
            document.getElementById('isCartpageBtn').style.display = 'block';
            var a = document.getElementById('dummy_email_button_journey_cart'); //or grab it by tagname etc
            a.href = getCookie('hkbn_journey_url');
        } else {
            document.getElementById('isAccountpageBtn').style.display = 'block';
            var a = document.getElementById('dummy_email_button_journey'); //or grab it by tagname etc
            a.href = getCookie('hkbn_journey_url');
        }
        delete_cookie('hkbn_journey_url');
    }
}

if (getCookie('hkbn_cart_url')) {
    window.location.href = getCookie('hkbn_cart_url');
    delete_cookie('hkbn_cart_url');
}
/*
var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
if (isMobile && document.getElementById("header__cart-toggle_d")) {
  document.getElementById("header__cart-toggle_d").remove();
}
*/
function getQueryStringByName(name) {
    var result = location.search.match(new RegExp('[?&]' + name + '=([^&]+)', 'i'));
    if (result == null || result.length < 1) {
        return '';
    }
    return result[1];
}
function redirectEc() {
    var redirect_link = 'https://www.hkbn.net/myhkbn/en/login?link_func=myhkbnmall';
    var link_path = getQueryStringByName('redirect_url');
    if (!link_path) {
        link_path = getQueryStringByName('checkout_url');
    }
    if (link_path) {
        redirect_link = redirect_link + '&redirect_url=' + link_path;
    }
    window.location.href = redirect_link;
}

function redirectEcCN() {
    var redirect_link = 'https://www.hkbn.net/myhkbn/tc/login?link_func=myhkbnmall';
    var link_path = getQueryStringByName('redirect_url');
    if (!link_path) {
        link_path = getQueryStringByName('checkout_url');
    }
    if (link_path) {
        redirect_link = redirect_link + '&redirect_url=' + link_path;
    }
    window.location.href = redirect_link;
}

async function redirectLogin(handle, productId, isProductInfo) {
    let addCart = false;
    if (handle || productId) {
        await getProductByHandle(handle);
        saveDataToStorage(productId, isProductInfo);
        addCart = true;
    }

    var redirectDomain =
        window.top.location.href.indexOf('uat') >= 0
            ? 'https://uat-shoppy-portal.hkbn.net'
            : 'https://shoppy-portal.hkbn.net';

    var redirect_link =
        getCookie('language') == 'cn' || !getCookie('language')
            ? redirectDomain + '/shoppy-login/web/tc/login'
            : redirectDomain + '/shoppy-login/web/en/login';

    if (window.top.location.href.indexOf('lang=') >= 0) {
        if (window.top.location.href.indexOf('lang=en') >= 0) {
            redirect_link = redirectDomain + '/shoppy-login/web/en/login';
        } else if (
            window.top.location.href.indexOf('lang=zh') >= 0 ||
            window.top.location.href.indexOf('lang=cn') >= 0 ||
            window.top.location.href.indexOf('lang=tc') >= 0
        ) {
            redirect_link = redirectDomain + '/shoppy-login/web/tc/login';
        } else {
        }
    }
    var redirectUrl;
    //当前url 自带redirect
    var link_path = getQueryStringByName('redirect_url');
    if (!link_path) {
        link_path = getQueryStringByName('checkout_url');
    }
    if (link_path) {
        redirectUrl = link_path;
    }
    // 堆砌 redirect URL
    if (!redirectUrl || typeof redirectUrl == 'undefined') {
        redirectUrl = escape(window.location.href);
    }

    if (typeof redirectUrl == 'undefined') {
        window.top.location.href = redirect_link;
    } else if (redirectUrl.length > 0) {
        if (addCart) {
            redirectUrl = unescape(redirectUrl);
            if (redirectUrl.includes('?')) redirectUrl = redirectUrl + '&addCart=1';
            else redirectUrl = redirectUrl + '?addCart=1';
            redirectUrl = escape(redirectUrl);
        }
        let pps = getParam(unescape(redirectUrl), 'pps');
        if (pps && pps.length > 0) {
            var newRedirectUrl = urlParamDel(unescape(redirectUrl), 'pps');
            redirect_link = redirect_link + '?redirect_url=' + escape(newRedirectUrl) + '&pps=' + pps;
        } else {
            redirect_link = redirect_link + '?redirect_url=' + redirectUrl;
        }
        window.top.location.href = redirect_link;
    }
}

/**
 * 删除当前url中指定参数
 * @param names 数组或字符串
 * @returns {string}
 */
function urlParamDel(url, names) {
    if (typeof names == 'string') {
        names = [names];
    }
    var loca = url;
    var obj = {};
    if (url.indexOf('?') != -1) {
        var paramStr = url.substr(url.indexOf('?'));
        var arr = paramStr.substr(1).split('&');
        //获取参数转换为object
        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].split('=');
            obj[arr[i][0]] = arr[i][1];
        }
        //删除指定参数
        for (var i = 0; i < names.length; i++) {
            delete obj[names[i]];
        }
        //重新拼接url
        if (Object.keys(obj).length > 0) {
            var urll =
                url.split('?')[0] +
                '?' +
                JSON.stringify(obj)
                    .replace(/[\"\{\}]/g, '')
                    .replace(/\:/g, '=')
                    .replace(/\,/g, '&');
            return urll;
        } else {
            return url.split('?')[0];
        }
    } else {
        return;
    }
}

function getParam(url, paramName) {
    var strs;
    var url = url || window.location.href; //获取url中"?"符后的字串
    var theRequest = new Object();
    var result;
    if (url.indexOf('?') != -1) {
        url = url.substr(url.indexOf('?'));
        var str = url.substr(1);
        strs = str.split('&');
        for (var i = 0; i < strs.length; i++) {
            var index = strs[i].indexOf('=');
            if (strs[i].slice(0, index) == paramName) {
                result = unescape(strs[i].slice(index + 1, strs[i].length));
            }
        }
    }
    return result;
}

function checkLastOrderDateTimeDifference(orderDate) {
    // 指定一个日期时间
    var specifiedDate = new Date(orderDate);

    // 获取当前日期时间
    var currentDate = new Date();

    // 计算时间差（以毫秒为单位）
    var timeDifference = currentDate - specifiedDate;

    // 将毫秒转换为天数
    var daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    // console.log('相差的天数：', daysDifference);
}

function setDefaultAddressDate() {
    // 获取指定的复选框
    var cartDefaultAddressFlagElement = document.querySelector('cart_default_address_flag');

    // 获取复选框的值
    var checkboxValue = cartDefaultAddressFlagElement.checked;
    var defaultAddressChooseDate = document.querySelector('default_address_click_date');
    if (checkboxValue) {
        var currentDate = new Date();
        // 修改输入标签的值
        defaultAddressChooseDate.value = currentDate;
    } else {
        defaultAddressChooseDate.value = '';
    }
}

function extend() {
    var extended = {};
    var i = 0;
    // Merge the object into the extended object
    var merge = function merge(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                // If property is an object, merge properties
                if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                    extended[prop] = extend(extended[prop], obj[prop]);
                } else {
                    extended[prop] = obj[prop];
                }
            }
        }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
        merge(arguments[i]);
    }

    return extended;
}

function serialize(form) {
    function stringKey(key, value) {
        var beginBracket = key.lastIndexOf('[');
        if (beginBracket === -1) {
            var _hash = {};
            _hash[key] = value;
            return _hash;
        }
        var newKey = key.substr(0, beginBracket);
        var newValue = {};
        newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
        return stringKey(newKey, newValue);
    }

    var hash = {};
    for (var i = 0, len = form.elements.length; i < len; i++) {
        var formElement = form.elements[i];
        if (formElement.name === '' || formElement.disabled) {
            continue;
        }

        if (
            formElement.name &&
            !formElement.disabled &&
            (formElement.checked ||
                /select|textarea/i.test(formElement.nodeName) ||
                /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
                    formElement.type
                ))
        ) {
            var stringKeys = stringKey(formElement.name, formElement.value);
            hash = extend(hash, stringKeys);
        }
    }

    return hash;
}

let loaded = false;
function addToCartAfterLogin() {
    const search = window.location.search;
    const searchArr = search.split('&');
    const role = window.gt && window.gt.role;
    const isEc = role == 'ec';
    if (searchArr.includes('?addCart=1') || (searchArr.includes('addCart=1') && !loaded)) {
        loaded = true;
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start'));
        let product = localStorage.getItem(isEc ? 'product_ec' : 'product');
        localStorage.removeItem('product');
        localStorage.removeItem('product_ec');
        if (product) {
            product = JSON.parse(product);
            fetch(window.theme.localeRootUrl + '/cart/add.js', {
                body: JSON.stringify({ items: [product] }),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
                },
            }).then(function (response) {
                // window.location.href = "/cart";
                const href = window.location.href;
                var newRedirectUrl = urlParamDel(unescape(href), 'addCart');
                document.documentElement.dispatchEvent(
                    new CustomEvent('cart:refresh', {
                        bubbles: true,
                    })
                );
                window.location.href = newRedirectUrl;
                window.location.reload();
                document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end'));
                
            });
        } else if (!loaded) {
            const href = window.location.href;
            var newRedirectUrl = urlParamDel(unescape(href), 'addCart');
            window.location.href = newRedirectUrl;
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end'));
        }

        // 删除数据
        //localStorage.removeItem("formData")
    }
}

function saveDataToStorage(productId, isProductInfo) {
    var formElement = document.querySelector(isProductInfo ? '.product-info-form' : `#product_form_${productId}`);
    var formData = serialize(formElement);
    let addon = false;
    if (formData.addonSelect) {
        for (let key in formData.addonSelect) {
            if (formData.addonSelect[key].checked) {
                addon = true;
                break;
            }
        }
    }
    if (window.localStorage && !addon) {
        // 保存数据
        localStorage.setItem('product', JSON.stringify(formData));

        const sku = formData['sku'];
        const variants = window.productInfo && window.productInfo.product.variants;
        if (!variants) return;
        const variant = variants.find((item) => item.sku === sku);
        if (variant && sku) {
            const { id } = variant;
            const formDataEc = {
                ...formData,
                id: id.toString(),
                quantity: formData.quantity,
                properties: window.productInfo.properties,
                'product-id': window.productInfo.product.id,
            };
            localStorage.setItem('product_ec', JSON.stringify(formDataEc));
        }
    } else {
        console.log('浏览器不支持localStorage');
    }
}

async function getProductByHandle(handle) {
    let addCart = false;
    const isEc = handle.includes('-ec');
    const origin = isEc ? '-ec' : '-nc';
    const replace = isEc ? '-nc' : '-ec';
    const new_handle = handle.replace(origin, replace);
    let properties = { pickup_detail: '', pickup_detail_en: '', tc_title: '' };

    // 发送请求
    await fetch(window.location.origin + '/products/' + new_handle + '?view=meta')
        .then((response) => response.text())
        .then((data) => {
            // 输出或处理你的数据
            var targetElement = document.getElementById('meta-section');
            targetElement.innerHTML = data;
            var formElement = document.querySelector(`.meta-info-form`);
            properties = serialize(formElement).properties;
        })
        .catch((error) => {
            // 输出或处理你的错误
            console.error('Error:', error);
        });

    let res = await fetch(window.theme.localeRootUrl + `/products/${new_handle}.js`, {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
        },
    });
    try {
        if (res.ok) {
            const product = await res.json();
            window.productInfo = {
                product,
                properties,
            };
            addCart = true;
        }
    } catch (error) {
        console.log('error', error);
    }
    return addCart;
}

window.addEventListener('DOMContentLoaded', function () {
    //Dom 渲染完即可执行 此时图片视频还可能没加载完
    addToCartAfterLogin();
    handleLang();
});
window.ShopifyAPI = window.ShopifyAPI || {};
window.ShopifyAPI.getCart = function(callback) {jQuery.getJSON('/cart.js', function (cart, textStatus) {if((typeof callback) === 'function') {callback(cart);}});};

// to do support ?lang=en
// function handleLang(){
//   const lang = getParam('', 'lang');
//   const href = urlParamDel(window.location.href, 'lang');
//   if(lang == 'en' && !href.includes('/en')){
//     let suffix = href.split('shoppy.hkbn.net')[1];
//     suffix = '/en' + suffix;
//     const url = window.location.origin + suffix;
//     window.location.href = url;
//   }else if(lang == 'tc' && href.includes('/en')){
//     const url = href.replace('/en','');
//     window.location.href = url;
//   }
// }

function handleLang() {
  const lang = getParam('', 'lang');
  if (!lang) return; // 没有lang参数时直接返回，不执行任何操作

  // 使用URL对象解析，避免字符串拼接错误
  const currentUrl = new URL(window.location.href);
  const pathname = currentUrl.pathname; // 路径部分（如/collections/entertainment/...）
  const hasEntertainment = /entertainment/i.test(pathname); // 检查路径是否含"entertainment"

  // 处理英文切换（lang=en）
  if (lang === 'en' && !pathname.startsWith('/en/')) {
    // 无论是否含"entertainment"，都添加/en，但用URL对象确保格式正确
    currentUrl.pathname = `/en${pathname}`; // 正确拼接：/en + 原路径
    currentUrl.searchParams.delete('lang'); // 移除lang参数，避免循环
    window.location.href = currentUrl.toString();
  }
  // 处理中文切换（lang=tc）
  else if (lang === 'tc' && pathname.startsWith('/en/')) {
    // 含"entertainment"的路径，更精确地移除/en
    if (hasEntertainment) {
      // 只移除路径开头的/en/，保留其他部分（如将/en/collections/...改为/collections/...）
      currentUrl.pathname = pathname.replace(/^\/en/, '');
    } else {
      currentUrl.pathname = pathname.replace('/en', '');
    }
    currentUrl.searchParams.delete('lang');
    window.location.href = currentUrl.toString();
  }
}


